import { Button } from "@/components/ui/button";
import { Camera, MapPin, MessageCircle } from "lucide-react";
import { COMPANY } from "@/lib/company";
import { trackEstimate } from "@/lib/track";

const STEPS = [
  {
    icon: Camera,
    step: "Step 1",
    title: "Rough Estimate",
    text: "Send photos/videos and receive a preliminary budget indication.",
  },
  {
    icon: MapPin,
    step: "Step 2",
    title: "Actual Price",
    text: "Free site inspection, detailed scope assessment and quotation.",
  },
];

export default function Pricing() {
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="py-20 lg:py-28 bg-neutral-950 text-white"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <p className="text-[11px] uppercase tracking-[0.25em] text-[#C5A059] font-semibold mb-3">
            Transparency
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight mb-5 leading-[1.1]">
            Clear Renovation Pricing. No Guesswork.
          </h2>
          <p className="text-base lg:text-lg text-neutral-300 leading-relaxed">
            Every property is different. Renovation cost depends on the property size, existing condition, scope of work, materials, finishes and level of customization.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10 max-w-4xl mx-auto">
          {STEPS.map((s) => (
            <div
              key={s.step}
              data-testid={`pricing-${s.step.replace(" ", "-").toLowerCase()}`}
              className="border border-neutral-800 p-8 hover:border-[#C5A059] transition-colors"
            >
              <p className="text-[10px] uppercase tracking-[0.25em] text-[#C5A059] font-semibold mb-4">{s.step}</p>
              <div className="w-10 h-10 bg-[#C5A059]/15 flex items-center justify-center mb-4">
                <s.icon className="w-5 h-5 text-[#C5A059]" />
              </div>
              <h3 className="font-heading text-2xl font-medium mb-2 uppercase tracking-wide">{s.title}</h3>
              <p className="text-sm text-neutral-400 leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href={COMPANY.estimateLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="pricing-cta"
            onClick={() => trackEstimate("pricing_section")}
          >
            <Button className="bg-[#C5A059] hover:bg-[#A88746] text-white rounded-none px-8 py-7 font-semibold tracking-wide">
              <MessageCircle className="w-5 h-5 mr-2" /> SEND PHOTOS &amp; GET A ROUGH ESTIMATE
            </Button>
          </a>
          <p className="text-xs text-neutral-500 mt-5">
            Photos give a rough estimate only — the actual price is confirmed after a free site inspection.
          </p>
        </div>
      </div>
    </section>
  );
}
